import styled from 'styled-components'
import { Button } from 'react-bootstrap'

export const MeetingRoomFormWrapper = styled.div`
  height: fit-content;
`

export const BreadcrumbRow = styled.div`
  margin-bottom: 16px;
  font-size: 0.875rem;
  color: #555;

  a {
    color: var(--primary, #0d6efd);
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`

export const FormHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;
`

export const FormTitle = styled.h1`
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0;
`

export const CardSection = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 32px 28px;
  margin-bottom: 32px;
`

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const FieldGroup = styled.div`
  margin-bottom: 20px;
`

export const FieldLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 600;
  color: #222;
  margin-bottom: 6px;
  display: block;
`

export const RequiredMark = styled.span`
  color: #dc3545;
  margin-left: 2px;
`

export const DescriptionCharCount = styled.span<{ $nearLimit?: boolean }>`
  display: block;
  margin-top: 4px;
  font-size: 0.75rem;
  text-align: right;
  color: ${({ $nearLimit }) => ($nearLimit ? '#dc3545' : '#6c757d')};
`

export const EquipmentRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`

export const RemoveIconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #aaa;
  padding: 0 4px;
  &:hover {
    color: #666;
  }
`

export const AddLink = styled.button`
  background: none;
  border: none;
  color: var(--primary, #0d6efd);
  font-size: 0.875rem;
  cursor: pointer;
  padding: 0;
  font-weight: 500;
  &:hover {
    text-decoration: underline;
  }
`

export const ImageNoteText = styled.small`
  font-size: 0.72rem;
  color: #888;
  display: block;
  margin-bottom: 10px;
`

export const FileItemRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  color: var(--primary, #0d6efd);
  font-size: 0.875rem;
`

export const UploadBtn = styled(Button)`
  background: #a0d6ff;
  border: 1px solid #a0d6ff;
  color: #01579e;
  font-size: 0.875rem;
  font-weight: 750;
  border-radius: 4px;
  &:hover,
  &:focus {
    background: #1b66c6;
    border-color: #185ab0;
    color: #fff;
  }
`

export const SectionDivider = styled.div`
  height: 1px;
  background: #ebebeb;
  margin: 24px 0 28px;
`

export const SectionLabel = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: #222;
  margin-bottom: 12px;
`

export const ImagesUploadRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`

export const ImagePreviewWrapper = styled.div`
  position: relative;
  display: inline-block;
`

export const ImagePreview = styled.img`
  width: 240px;
  height: 74px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  display: block;
`

export const ImagePreviewRemoveButton = styled.button`
  position: absolute;
  top: -8px;
  right: -8px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #0d6efd;
  border: 2px solid white;
  color: white;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  padding: 0;
  line-height: 1;

  &:hover {
    background-color: #0b5ed7;
  }
`
